export default "__VITE_ASSET__BmhwoDDX__"